(function () {
  // Evita correr duas vezes se o script for incluído em mais de um sítio
  if (window.__zapierQuoteLoaded) return;
  window.__zapierQuoteLoaded = true;

  console.log("Zapier: init");

  const ZAPIER_HOOK_URL = "https://hooks.zapier.com/hooks/catch/20493613/ughn2bt";
  const SHARED_SECRET_TOKEN = ""; // opcional: validar com um Filter no Zapier

  const FORM_SELECTOR = "#omgrfq-quote-list-form";

  const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "gclid"];
  const COOKIE_PREFIX = "attr_";
  const ATTR_STORAGE_KEY = "attribution_params_v2";
  const ATTR_COOKIE_DAYS = 90;

  // "last"  = UTMs novos no URL substituem os guardados (recomendação Otter Ridge / Dustin)
  // "first" = mantém os primeiros UTMs capturados
  const ATTRIBUTION_MODE = "last";

  /* ---------- Cookies ---------- */

  function setCookie(name, value, days) {
    let cookie =
      encodeURIComponent(name) + "=" + encodeURIComponent(value) +
      "; path=/; max-age=" + days * 24 * 60 * 60 + "; SameSite=Lax";
    if (location.protocol === "https:") cookie += "; Secure";
    document.cookie = cookie;
  }

  function deleteCookie(name) {
    document.cookie = encodeURIComponent(name) + "=; path=/; max-age=0; SameSite=Lax";
  }

  function getCookie(name) {
    const needle = encodeURIComponent(name) + "=";
    for (const part of document.cookie.split("; ")) {
      if (part.indexOf(needle) === 0) return decodeURIComponent(part.slice(needle.length));
    }
    return "";
  }

  /* ---------- Atribuição ---------- */

  // Lê do localStorage; o que faltar vai buscar aos cookies attr_*
  // (inclui cookies deixados pela versão antiga v1, que usa os mesmos nomes)
  function loadAttribution() {
    let out = {};
    try {
      out = JSON.parse(localStorage.getItem(ATTR_STORAGE_KEY) || "{}") || {};
    } catch (e) {
      out = {};
    }
    for (const key of PARAMS) {
      if (!out[key]) {
        const value = getCookie(COOKIE_PREFIX + key);
        if (value) out[key] = value;
      }
    }
    return out;
  }

  function captureAttribution() {
    const urlParams = new URLSearchParams(window.location.search);
    const incoming = {};
    for (const key of PARAMS) {
      const value = urlParams.get(key);
      if (value) incoming[key] = value;
    }

    let stored = loadAttribution();

    if (Object.keys(incoming).length) {
      if (ATTRIBUTION_MODE === "last") {
        // Substitui o conjunto inteiro para não misturar campanhas diferentes
        stored = incoming;
      } else {
        for (const key of Object.keys(incoming)) {
          if (!stored[key]) stored[key] = incoming[key];
        }
      }
    }

    try {
      localStorage.setItem(ATTR_STORAGE_KEY, JSON.stringify(stored));
    } catch (e) {}

    for (const key of PARAMS) {
      if (stored[key]) setCookie(COOKIE_PREFIX + key, stored[key], ATTR_COOKIE_DAYS);
      else deleteCookie(COOKIE_PREFIX + key);
    }

    console.log("Zapier: attribution captured (" + ATTRIBUTION_MODE + "-touch)", stored);
  }

  captureAttribution();

  /* ---------- Payload ---------- */

  function safeText(el) {
    return el ? String(el.value || el.textContent || "").trim() : "";
  }

  function buildLineItems() {
    const rows = document.querySelectorAll("table.omgrfq-table tr");
    const items = [];
    for (const row of rows) {
      const nameEl = row.querySelector("div.omgrfq_product_title");
      const infoEl = row.querySelector("div.omgrfq_product_title-info");
      const qtyEl = row.querySelector("input.item_qty");

      const name = nameEl ? nameEl.textContent.trim() : "";
      const info = infoEl ? infoEl.textContent.trim() : "";
      const qty = qtyEl ? String(qtyEl.value || "").trim() : "";

      if (name || info || qty) {
        items.push({ name: name, info: info, qty: qty ? Number(qty) : 0 });
      }
    }
    return items;
  }

  // Estrutura igual à anterior, para não partir o mapeamento existente no Zapier
  function buildPayload(quoteForm) {
    const q = (sel) => quoteForm.querySelector(sel);
    const f0 = q('input[name="omgrfq-form_0"]');     // first name
    const f1 = q('input[name="omgrfq-form_1"]');     // last name
    const f2 = q('input[name="omgrfq-form_2"]');     // email
    const f3 = q('input[name="omgrfq-form_3"]');     // company
    const f4 = q('input[name="omgrfq-form_4"]');     // city
    const s5 = q('select[name="omgrfq-form_5"]');    // state
    const f6 = q('input[name="omgrfq-form_6"]');     // phone
    const f7 = q('textarea[name="omgrfq-form_7"]');  // comments

    const state = s5 && s5.options[s5.selectedIndex]
      ? s5.options[s5.selectedIndex].textContent.trim()
      : "";

    const attr = loadAttribution();

    return {
      visitor: {
        firstName: safeText(f0),
        lastName: safeText(f1),
        email: safeText(f2),
        phone: safeText(f6),
        company: safeText(f3),
        city: safeText(f4),
        state: state,
        comments: safeText(f7)
      },
      quote: {
        items: buildLineItems()
      },
      attribution: {
        utm_source: attr.utm_source || "",
        utm_medium: attr.utm_medium || "",
        utm_campaign: attr.utm_campaign || "",
        utm_term: attr.utm_term || "",
        gclid: attr.gclid || ""
      },
      metadata: {
        pageUrl: window.location.href,
        referrer: document.referrer || "",
        submittedAt: new Date().toISOString(),
        userAgent: navigator.userAgent || ""
      },
      auth: {
        token: SHARED_SECRET_TOKEN || ""
      }
    };
  }

  /* ---------- Envio ---------- */

  function postToZapier(payload) {
    const body = JSON.stringify(payload);
    console.log("Zapier: postToZapier", payload);

    if (navigator.sendBeacon) {
      try {
        const blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
        const ok = navigator.sendBeacon(ZAPIER_HOOK_URL, blob);
        console.log("Zapier: sendBeacon ok =", ok);
        if (ok) return;
      } catch (e) {
        console.log("Zapier: sendBeacon fail", e);
      }
    }

    // Fallback (resposta é opaca por causa do no-cors)
    fetch(ZAPIER_HOOK_URL, {
      method: "POST",
      mode: "no-cors",
      keepalive: true,
      headers: { "Content-Type": "text/plain;charset=UTF-8" },
      body: body
    }).catch((err) => console.log("Zapier: fetch error", err));
  }

  /* ---------- Listeners (um só caminho de envio, com proteção contra duplicados) ---------- */

  let lastSentAt = 0;

  function sendOnce(quoteForm, reason) {
    const now = Date.now();
    if (now - lastSentAt < 1500) return;

    // Só envia se o formulário tiver email (evita runs vazias no Zapier)
    const emailEl = quoteForm.querySelector('input[name="omgrfq-form_2"]');
    if (!safeText(emailEl)) {
      console.log("Zapier: email vazio, não envia (" + reason + ")");
      return;
    }

    lastSentAt = now;
    console.log("Zapier: sending (reason: " + reason + ")");
    postToZapier(buildPayload(quoteForm));
  }

  // Submit: só o formulário final do Quote Snap (ignora o form de adicionar produto/comentários)
  document.addEventListener("submit", function (e) {
    const form = e.target;
    if (!form || !form.matches || !form.matches(FORM_SELECTOR)) return;
    sendOnce(form, "submit");
  }, true);

  // Fallback: clique no botão "Request Quote" dentro do formulário final
  document.addEventListener("click", function (e) {
    const btn = e.target && e.target.closest
      ? e.target.closest('button[type="submit"], input[type="submit"]')
      : null;
    if (!btn) return;

    const form = btn.closest(FORM_SELECTOR);
    if (!form) return;

    // Se o browser vai bloquear o envio por campos inválidos, não envia
    if (typeof form.checkValidity === "function" && !form.checkValidity()) return;

    setTimeout(() => sendOnce(form, "click-submit"), 0);
  }, true);
})();